import FilterPanel from "../../components/sections/FilterPanel";
import RegistroForm from "../../components/forms/RegistroForm";
import RegistrosTable from "./RegistrosTable";
import RegistrosToolbar from "./RegistrosToolbar";

export default function RegistrosTab({
  registros,
  tournaments,
  onRefreshCommonTournaments,
  completePreferences,
  setCompletePreferences,
  filtered,
  pageSlice,
  totalPages,
  safePage,
  page,
  setPage,
  activeFilters,
  filters,
  setFilters,
  showFilters,
  setShowFilters,
  clearFilters,
  registroForm,
  registroModal,
  getTournament,
  handleSaveRegistro,
  handleEditRegistro,
  setDeleteTarget,
  displayCurrency,
}) {
  return (
    <div>
      <RegistrosToolbar
        registros={registros}
        filtered={filtered}
        activeFilters={activeFilters}
        completePreferences={completePreferences}
        setCompletePreferences={setCompletePreferences}
        onRefreshCommonTournaments={onRefreshCommonTournaments}
        registroForm={registroForm}
        registroModal={registroModal}
        setShowFilters={setShowFilters}
      />

      {showFilters && (
        <FilterPanel
          filters={filters}
          onChange={setFilters}
          tournaments={tournaments}
          registros={registros}
          onClear={clearFilters}
        />
      )}

      {registroModal.isOpen && !registroModal.editingId && (
        <RegistroForm
          form={registroForm.values}
          errors={registroForm.errors}
          tournaments={tournaments}
          completePreferences={completePreferences}
          onCompletePreferencesChange={setCompletePreferences}
          onSubmit={handleSaveRegistro}
          onCancel={() => {
            registroModal.close();
            registroForm.reset();
          }}
          isEditing={!!registroModal.editingId}
          onChange={registroForm.setValues}
          getTournament={getTournament}
          displayCurrency={displayCurrency}
        />
      )}

      <RegistrosTable
        filtered={filtered}
        pageSlice={pageSlice}
        safePage={safePage}
        totalPages={totalPages}
        page={page}
        setPage={setPage}
        activeFilters={activeFilters}
        registroForm={registroForm}
        registroModal={registroModal}
        tournaments={tournaments}
        getTournament={getTournament}
        handleEditRegistro={handleEditRegistro}
        handleSaveRegistro={handleSaveRegistro}
        setDeleteTarget={setDeleteTarget}
        displayCurrency={displayCurrency}
      />
    </div>
  );
}
